module.exports = __webpack_public_path__ + "img/middle-Market.a3d01a71.png";